import { defaultSounds } from '@pascal/pascal-core/shared/core/services/sound/defaultSounds';
import { SoundService as BaseSoundService, SoundType as BaseSoundTypes } from '@pascal/pascal-core';

defaultSounds.music.loop = true;

const SoundTypes = {
  ...BaseSoundTypes,
  Wheel: 'Wheel',
};

const options = [
  {
    src: 'wheel.mp3',
    name: SoundTypes.Wheel,
    autoplay: false,
    html5: true,
  },
];
class SoundService extends BaseSoundService {}

const soundService = new SoundService({
  options,
});

export { SoundTypes as soundTypes, soundService };
